module.exports = __webpack_public_path__ + "static/img/wen-chang-jin.9eb93f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/wen-chang-jin.jpg
// module id = qAMC
// module chunks = 1